import { Purpose } from '@axo/shared/data-access/types';
import { z } from 'zod';
import { MarketingConsentFields } from '../../../../../hooks/useMarketingConsent';
import {
  MAX_LOAN_AMOUNT,
  MAX_LOAN_DURATION,
  MIN_LOAN_AMOUNT,
  PHONE_REGEX,
} from '../globals';

export const finlandStep1Schema = z
  .object({
    'LoanApplication/AppliedAmount': z.coerce
      .number()
      .min(MIN_LOAN_AMOUNT)
      .max(MAX_LOAN_AMOUNT),
    'LoanApplication/LoanDuration': z.coerce
      .number()
      .min(1)
      .max(MAX_LOAN_DURATION),
    'Customer/Email': z
      .string({ required_error: 'Email.error.required' })
      .email('Email.error.pattern'),
    'Customer/MobilePhoneNumber': z.preprocess(
      (value) => String(value).replaceAll(' ', ''),
      z
        .string()
        .min(1, { message: 'MobilePhoneNumber.error.required' })
        .refine(
          (value) => PHONE_REGEX.test(value),
          'MobilePhoneNumber.error.pattern'
        )
    ),
    'LoanApplication/InitialPurpose': z
      .nativeEnum(Purpose)
      .default(Purpose.Other),
    'LoanApplication/Purpose': z.nativeEnum(Purpose).default(Purpose.Other),
  })
  .transform((data) => ({
    ...data,
    'LoanApplication/Purpose': data['LoanApplication/InitialPurpose'],
  }));

export type Step1Data = z.infer<typeof finlandStep1Schema> &
  MarketingConsentFields;

export default finlandStep1Schema;
